function lineStartsBlock(line) {
  return /^(if|for|while|switch|try|function)\b/i.test(line)
}

function lineStartsIntermediateBlock(line) {
  return /^(else|elseif|case|otherwise|catch)\b/i.test(line)
}

function lineClosesBlock(line) {
  return /^(end|else|elseif|case|otherwise|catch)\b/i.test(line)
}

function trimTrailingWhitespace(text) {
  return text.replace(/[ \t]+$/g, '')
}

export function formatTianyuanCode(source) {
  const lines = String(source || '').split('\n')
  let indentLevel = 0

  const formatted = lines.map((rawLine) => {
    const withoutTrailingSpace = trimTrailingWhitespace(rawLine)
    const trimmed = withoutTrailingSpace.trim()
    if (!trimmed) return ''

    if (lineClosesBlock(trimmed)) {
      indentLevel = Math.max(indentLevel - 1, 0)
    }

    const prefix = '  '.repeat(indentLevel)
    const rendered = `${prefix}${trimmed}`

    if (lineStartsBlock(trimmed) || lineStartsIntermediateBlock(trimmed)) {
      indentLevel += 1
    }

    return rendered
  })

  return formatted.join('\n').replace(/\n{3,}/g, '\n\n')
}

export function normalizeLintResponse(body) {
  const diagnostics = Array.isArray(body?.diagnostics) ? body.diagnostics : []
  return diagnostics.map((item) => ({
    line: Number.isFinite(item?.line) ? item.line : null,
    column: Number.isFinite(item?.column) ? item.column : null,
    severity: item?.severity || 'error',
    message: String(item?.message || ''),
  }))
}
